/**
 * (Группа 4 · экран 2) Карточка отеля — 7 вкладок (дизайн v4).
 *
 * Вкладки: Обзор / Подписка / Биллинг / Пользователи / Аудит / Здоровье /
 * Миграции. В каркасе реализованы переключение вкладок и описание секций.
 * Реальные данные подключаются по мере появления endpoint'ов:
 *   - Аудит вкладка → REAL GET /v1/admin/tenants/{id}/audit
 *   - Подписка/продления → REAL .../subscription-extensions
 *   - остальные вкладки → TODO backend.
 */
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';

const TABS = [
  { id: 'overview', label: 'Обзор' },
  { id: 'subscription', label: 'Подписка' },
  { id: 'billing', label: 'Биллинг' },
  { id: 'users', label: 'Пользователи' },
  { id: 'audit', label: 'Аудит' },
  { id: 'health', label: 'Здоровье' },
  { id: 'migration', label: 'Миграции' },
] as const;

type TabId = (typeof TABS)[number]['id'];

const TAB_NOTE: Record<TabId, string> = {
  overview: 'KPI, юр. данные, статус интеграций, опасные действия — каркас (TODO backend агрегата отеля).',
  subscription: 'Период, автопродление, история платежей — REAL .../subscription-extensions + TODO биллинг.',
  billing: 'Счета, транзакции, задолженность — REAL invoices/payments API.',
  users: 'Сотрудники с ролями + кнопка impersonation — TODO backend списка пользователей отеля.',
  audit: 'Аудит-цепочка отеля + проверка — REAL GET /v1/admin/tenants/{id}/audit.',
  health: 'Латентность API/БД, ошибки, статус PMS — TODO backend per-tenant health.',
  migration: 'Применённые/ожидающие миграции схемы — REAL per-tenant migrations (мониторинг).',
};

export function HotelDetailPage(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const [tab, setTab] = useState<TabId>('overview');

  return (
    <section className="hsc-page" data-testid="hotel-detail">
      <Link to="/hotels" className="admin-link">← К списку отелей</Link>
      <h1 className="hsc-page__title">Отель {id}</h1>

      <div className="admin-tabs" role="tablist">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={tab === t.id}
            className={'admin-tab' + (tab === t.id ? ' admin-tab--active' : '')}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="admin-tab-panel" role="tabpanel" data-testid={`hotel-tab-${tab}`}>
        <p className="admin-stub__source">{TAB_NOTE[tab]}</p>
        <p className="admin-stub__badge">Каркас вкладки</p>
      </div>
    </section>
  );
}
